import { useQuery } from '@tanstack/react-query'
import { type ReactNode } from 'react'

import { Spinner } from '~/shadcn/ui/spinner'
import { useApiClientUser } from '~/@api/client/useApiClientUser'
import { getApiErrorMessage } from '~/@lib/utils/error.utils'
import { QuestionsContextV1 } from './questions'

export function QuestionsProviderV1({ children }: { children: ReactNode }) {
  const client = useApiClientUser()
  const { data, error, isLoading } = useQuery({
    queryKey: ['investorAnalysisDefinition', '1'],
    queryFn: async () => {
      const resp =
        await client.user.onboardingControllerGetInvestorAnalysisDefinition(
          { version: '1' },
          { secure: true }
        )
      return resp.data.definition
    },
    staleTime: Infinity,
  })

  if (isLoading) {
    return (
      <div className="flex justify-center items-center h-full">
        <Spinner className="size-10" />
      </div>
    )
  }

  if (!data) {
    return (
      <p className="font-medium">
        {getApiErrorMessage(error, 'Investičný dotazník sa nepodarilo načítať.')}
      </p>
    )
  }

  return (
    <QuestionsContextV1.Provider value={data}>
      {children}
    </QuestionsContextV1.Provider>
  )
}
